// extracted by mini-css-extract-plugin
export default {"mediaObject":"MediaObject_mediaObject__MwiGt","active":"MediaObject_active__SO0Tw","thumbnail":"MediaObject_thumbnail__LsfnV","caption":"MediaObject_caption__+qZq2"};